// extracted by mini-css-extract-plugin
export default {"timer":"style_timer__6AIf2"};